import {
  BaseResource,
  idObjectReferenceSerializer,
  ResourceAction,
  ResourceActionV2,
} from "@legacy-megarax/rest-resource";
import { MSerializers } from "@legacy-megarax/serializers";

import { permissions } from "./PermissionList";

const authorizedUsersAction = ResourceActionV2({
  name: "authorizedUsers",
  method: "get",
  querySerializer: MSerializers.object({
    permission: MSerializers.stringOneOf(...permissions),
  }),
  responseValueSerializer: MSerializers.array(idObjectReferenceSerializer),
});

export const permissionResource = BaseResource(["iam", "permissions"], {
  authorizedUsers: authorizedUsersAction,
});
